//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import html2canvas from 'html2canvas'
export default {
    data(){
        return {
            data:"",
            list:{},
            id:this.$route.query.id,
            doctorid:this.$route.query.doctorid
        }
    },
    methods:{
        getImg(){
            let _this=this;
            html2canvas(this.$refs.imageWrapper,{
                backgroundColor: null
            }).then((canvas)=>{
                let dataURL = canvas.toDataURL("image/png");
                _this.data = dataURL;
            })
        },
        getWxcode(){
            let _this = this;
            this.$doRequest("/api/phoneinvitepatient/getbusinesscard",{parameters:this.doctorid,parametersone:this.id},res=>{
                _this.list=res;
                _this.getImg();
            })
        }
    },
    mounted(){
        document.title="调理药方"
        this.getWxcode();
    }

}



// WEBPACK FOOTER //
// ./src/views/wxQrcode/index.vue